module.exports = __webpack_public_path__ + "img/FHE.c2d06dca.png";